import { faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNonInitialEffect } from '@versiondos/hooks';
import clsx from 'clsx';
import { Input } from 'components/UI/V3/Forms/Input/Input';
import { Switch } from 'components/UI/V3/Forms/Switch';
import { FunctionComponent, useEffect, useState } from 'react';
import { isEmailValid as validateEmail } from '@spike/validations';
import { isTemporalEmail } from 'utils/ValidationUtils';
import styles from './SendingInformation.module.scss';

interface SendingInformationProps {
    email: string;
    className?: string;
    disabled?: boolean;
    onChange: (sendInvoice: boolean, email: string, emailIsValid: boolean) => void;
    hideEmail?: boolean;
}

export const SendingInformation: FunctionComponent<SendingInformationProps> = props => {
    const [sendInvoice, setSendInvoice] = useState((isTemporalEmail(props.email) ? '' : props.email).length > 0);
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [email, setEmail] = useState(isTemporalEmail(props.email) ? '' : props.email);

    useNonInitialEffect(() => {
        const timer: NodeJS.Timer = setTimeout(() => {
            props.onChange && props.onChange(sendInvoice, email, validateEmail(email));
        }, 200);
        return () => clearTimeout(timer);
    }, [email, sendInvoice]);

    useEffect(() => {
        setIsEmailValid(validateEmail(email));
    }, [email]);

    const changeEmailHandler = (value: string) => {
        setEmail(value);
    };

    if (props.hideEmail && email.length === 0) {
        return null;
    }

    return (
        <div className={clsx(styles.root, props.className)}>
            <div className={styles.header}>
                <span className={styles.title}>Send Invoice</span>
                <Switch
                    id="booking_payment_send_info_checkbox_receipt"
                    checked={sendInvoice}
                    disabled={props.disabled}
                    onChange={setSendInvoice}
                />
            </div>
            {sendInvoice && !props.hideEmail && (
                <div className={styles.emailField}>
                    <Input
                        id="booking_payment_send_info_email_text_input"
                        type="email"
                        value={email}
                        disabled={props.disabled}
                        autoFocus={false}
                        autoComplete="off"
                        onChange={event => changeEmailHandler(event.target.value)}
                        endIcon={
                            <FontAwesomeIcon
                                icon={isEmailValid ? faCheck : faTimes}
                                className={isEmailValid ? styles.emailValid : styles.emailInvalid}
                            />
                        }
                    />
                </div>
            )}
        </div>
    );
};

export default SendingInformation;
